export function validateMobile(mobile, regex) {
  if (mobile) {
    let reg = new RegExp(regex);
    if (!reg.test(mobile)) {
      return false;
    }
  }

  return true;
}

export function checkLoginNonEmpty(mobile, email, loginState) {
  if (loginState == 0) {
    if (mobile.length > 0) {
      return true;
    } else {
      return false;
    }
  } else {
    if (email) {
      return true;
    } else {
      return false;
    }
  }

  return true;
}

export function validateEmail(email) {
  if (email) {
    var re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }
  return true;
}
